import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { NotificationService } from '../notification.service';

import { SessionService } from '../session.service';

@Injectable({
    providedIn: 'root'
})
export class StripeService {
    constructor(private router: Router,
                private sessionService: SessionService,
                private translateService: TranslateService,
                private notificationService: NotificationService) { }

    checkStripe(): Observable<boolean> {
        return new Observable(observable => {
            if (!this.sessionService.getCenterInfo().paymentConfiguration.centerHasActiveOnlinePayments()) {
                this.notificationService.showErrorMessage(this.translateService.instant('no_integration_error'));
                this.router.navigateByUrl('customer/wallet');
                observable.next(false);
            } else {
                observable.next(true);
            }
        });
    }
}
